import React from "react";
// import { FormField } from "../../particles/formFieldRHF";
// import { NotificationCard } from "../../organisms/notificationCard";

import { FormField, NotificationCard } from "@arp/react-ndbx";

import { useTheme } from "@mui/material/styles";
import {
  ToggleButton,
  ToggleButtonGroup as TBGroup,
  FormHelperText,
  FormControl,
  Box,
  Stack,
  Typography,
  SvgIcon,
} from "@mui/material";

//----------------------------------------------------------------

const displayType = (icon, imageSize) => {
  if (icon == null) return;

  if (typeof icon == "string") {
    return (
      <Box
        component="img"
        sx={{
          maxHeight: imageSize,
          maxWidth: imageSize,
          overflow: "hidden",
        }}
        alt="The house from the offer."
        src={icon}
      />
    );
  } else {
    return <SvgIcon fontSize="large">{icon}</SvgIcon>;
  }
};

const RHFToggleButtonGroup = React.forwardRef((props, ref) => (
  <FormField ref={ref} Component={RHFToggleButtonGroupImpl} {...props} />
));

const RHFToggleButtonGroupImpl = React.forwardRef(
  (
    {
      name,
      size,
      value,
      onChange,
      error,
      helperText,
      variant,
      disabled = false,
      items = [],
      showErrorCard = true,
      position = "center",
      extendedError = { title: null, additionalText: null },
      blowLabelFontSize = "14px",
      iconSize = 84,
      imageSize = 55,
    },
    ref
  ) => {
    const theme = useTheme();
    return (
      <FormControl size={size} error={error} sx={{ width: "100%" }}>
        <TBGroup
          inputRef={ref}
          value={value}
          exclusive={true}
          color="secondary"
          onChange={onChange}
          name={name}
          variant={variant}
          sx={{
            justifyContent: position ? position : "center",
            display: "grid",
            gridAutoFlow: "column",
            gridTemplateColumns: "auto auto",
            gridGap: { xs: "64px", lg: "48px" },
            outline: "0px solid green",
            alignItems: "flex-start",
          }}
        >
          {items.map((item, index) => {
            return (
              <ToggleButton
                disabled={disabled}
                variant={error === true ? "circle-error" : "circle"}
                value={item.value}
                key={item.value}
                // sx={{
                //   "&.Mui-selected": {
                //     backgroundColor: "red",
                //   },
                // }}
              >
                {item.label}
              </ToggleButton>
            );
          })}
          {/* {items.map((item) => {
            {
              if ("icon" in item) {
                const { icon, value, label } = { ...item };
                return (
                  <Stack alignItems={"center"}>
                    <ToggleButton variant="circle" value={value}>
                      {displayType(icon, imageSize)}
                    </ToggleButton>

                    <Typography
                      sx={{
                        fontSize: blowLabelFontSize,
                        maxWidth: iconSize,
                        maxHeight: iconSize,
                        paddingTop: 1,
                        color: theme.palette.action.PrimaryAction500,
                        lineHeight: 1.2,
                      }}
                    >
                      {label}
                    </Typography>
                  </Stack>
                );
              } else {
                return (
                  <ToggleButton
                    disabled={disabled}
                    variant={error === true ? "circle-error" : "circle"}
                    value={item.value}
                    key={item.value}
                  >
                    {item.label}
                  </ToggleButton>
                );
              }
            }
          })} */}
        </TBGroup>
        <Box mt={2}>
          {helperText && showErrorCard === true && (
            <NotificationCard message={helperText} {...extendedError} />
          )}
          {helperText && showErrorCard === false && (
            <FormHelperText sx={{ color: theme.palette.signal.Error600 }}>
              {helperText}
            </FormHelperText>
          )}
        </Box>
      </FormControl>
    );
  }
);

export default RHFToggleButtonGroup;
